var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/viewmodels/memberconfigurator',["require", "exports", "models/portal", "common/viewmodelbase", "common/parts", "common/tuple", "common/commands", "areas/navigationmanager/services/mappings", "areas/navigationmanager/parts/loadclient", "areas/navigationmanager/parts/loadnavigation", "areas/navigationmanager/parts/loadmodulelocks", "areas/navigationmanager/parts/savemodulelocks"], function (require, exports, Portal, ViewModel, Parts, Tuple, Commanding, Mapping, LoadClient, LoadNavigation, LoadModuleLocks, SaveModuleLocks) {
    "use strict";
    var MemberConfiguratorViewModel = (function (_super) {
        __extends(MemberConfiguratorViewModel, _super);
        // #region ctor
        function MemberConfiguratorViewModel() {
            _super.call(this);
            this._lockedModules = ko.observableArray();
            this.navigationItems = [];
            this.shortcuts = [];
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.title = $.t("app:modules.navigationManager.headline_title", { ifMissing: "Navigationskonfiguration" });
            ko.track(this, ["currentNode", "selectedNode", "shortcuts", "navigationItems"]);
        }
        // #endregion
        // #region overrides
        MemberConfiguratorViewModel.prototype.onActivated = function (context) {
            this._memberId = context.queryString.memberId;
            return this.initialize(this._memberId);
        };
        MemberConfiguratorViewModel.prototype.isDisabled = function (symbol) {
            if (symbol == null)
                return true;
            if (symbol.shopId == null)
                return false;
            return this._lockedModules.indexOf(symbol.shopId.toLowerCase()) != -1;
        };
        MemberConfiguratorViewModel.prototype.initialize = function (memberId) {
            var _this = this;
            var clientId = memberId; // jQuery.base64.decode(memberId, true);
            var progress = new Parts.Progress(this.taskManager);
            var join = Parts.PartBinder.bind(new Parts.Join(), progress.process.bind(progress));
            var loadClient = Parts.PartBinder.bind(new LoadClient(), join.first.bind(join));
            var joinNavigator = Parts.PartBinder.bind(new Parts.Join(), join.second.bind(join));
            var loadNavigation = Parts.PartBinder.bind(new LoadNavigation(), joinNavigator.first.bind(joinNavigator));
            var loadModuleLocks = Parts.PartBinder.bind(new LoadModuleLocks(), joinNavigator.second.bind(joinNavigator));
            progress.output.connect(function (data) {
                var client = data.item1;
                var navigatorData = data.item2;
                _this.breadCrumb.items.push(Portal.BreadCrumbItem.from(client.name, "fa-user"));
                Enumerable.From(navigatorData.item2)
                    .ForEach(function (m) { return _this._lockedModules.push(m); });
                _this.onNavigate(Mapping.parseNode(navigatorData.item1, null));
            }, this);
            this.saveModuleLocksCommand = new Commanding.DelegateCommand(this.onSaveModuleLocks, this);
            this.editNodeCommand = new Commanding.DelegateCommand(this.onEditNode, this);
            this.navigateCommand = new Commanding.DelegateCommand(this.onNavigate, this);
            this.lockNavigationNodeCommand = new Commanding.DelegateCommand(this.onLockNavigationNode, this);
            this.unlockNavigationNodeCommand = new Commanding.DelegateCommand(this.onUnlockNavigationNode, this);
            var workStatus = $.t("app:modules.navigationManager.message_loadBaseInformations", { ifMissing: "Basisinformationen werden geladen." });
            progress.start(workStatus, function () {
                loadClient.process(clientId);
                loadNavigation.process(clientId);
                loadModuleLocks.process(clientId);
            });
            return progress.deferred.promise;
        };
        // #region command handling
        MemberConfiguratorViewModel.prototype.onNavigate = function (symbol) {
            var _this = this;
            this.currentNode = symbol;
            var nodeType = symbol.type;
            var navigationItems = [];
            if (nodeType != "ApplicationLink") {
                this.selectedNode = null;
                this.shortcuts.removeAll();
                this.navigationItems.removeAll();
                var children = nodeType == "ApplicationLink" ? symbol.parent.children : symbol.children;
                var list = nodeType == "Application" || nodeType == "ApplicationLink" ? this.shortcuts : navigationItems;
                Enumerable.From(children)
                    .ForEach(function (child) {
                    list.push(child);
                });
                // gruppierung
                Enumerable.From(navigationItems)
                    .GroupBy(function (x) { return x.groupId; })
                    .ForEach(function (group) {
                    var itm = { key: group.Key(), list: group.ToArray() };
                    _this.navigationItems.push(itm);
                });
            }
        };
        MemberConfiguratorViewModel.prototype.onEditNode = function (symbol) {
            this.selectedNode = symbol;
        };
        MemberConfiguratorViewModel.prototype.onSaveModuleLocks = function (symbol) {
            var saveModuleLocks = Parts.PartBinder.bind(new SaveModuleLocks(this.taskManager), function (symbol) { });
            var tuple = new Tuple(this._memberId, this._lockedModules);
            saveModuleLocks.process(tuple);
        };
        MemberConfiguratorViewModel.prototype.onLockNavigationNode = function (symbol) {
            if (!this.isDisabled(symbol)) {
                this._lockedModules.push(symbol.shopId.toLowerCase());
                this.onNavigate(this.currentNode);
                this.selectedNode = symbol;
            }
        };
        MemberConfiguratorViewModel.prototype.onUnlockNavigationNode = function (symbol) {
            if (this.isDisabled(symbol)) {
                this._lockedModules.remove(symbol.shopId.toLowerCase());
                this.onNavigate(this.currentNode);
                this.selectedNode = symbol;
            }
        };
        return MemberConfiguratorViewModel;
    }(ViewModel.ViewModelBase));
    return MemberConfiguratorViewModel;
});

